module.exports = __webpack_public_path__ + "static/winnebagocjcc-cef6da8e30254e9ea63f74b0c7400044.png";